export const FONTS = {
  regular: 'Vazirmatn-Regular',
};